import React, { useRef, useLayoutEffect, useState, useMemo } from 'react';
import MultiCarousel from './MultiCarousel'

const RecipeListCarousel = ({ filters, recipes, heading }) => {
    const [currentFilter, setCurrentFilter] = useState(1)
    const [filteredRecipes, setFilteredRecipes] = useState(recipes)

    const carouselSettings = {
        responsive: {
            smallScreen: {
                breakpoint: {max: 550, min: 0},
                items: 1,
                paritialVisibilityGutter: 50,
                slidesToSlide: 1
            },
            mediumScreen: {
                breakpoint: {max: 1024, min: 550},
                items: 2,
                paritialVisibilityGutter: 50,
                slidesToSlide: 2
            },
            largeScreen: {
                breakpoint: {max: 1124, min: 1024},
                items: 3,
                paritialVisibilityGutter: 0,
                slidesToSlide: 3
            },
            xLargeScreen: {
                breakpoint: {max: 1400, min: 1124},
                items: 3,
                paritialVisibilityGutter: 50,
                slidesToSlide: 3
            },
            xXLargeScreen: {
                breakpoint: {max: 9999, min: 1400},
                items: 4,
                paritialVisibilityGutter: 0,
                slidesToSlide: 4
            },
        }   
    }

    const MemoMultiCarousel = useMemo(() => MultiCarousel)

    const FilterItems = (filter) => {
        setCurrentFilter(filter.key)
        setFilteredRecipes(recipes.filter(recipe => recipe.categories.includes(filter.key)))
    }

    return (
        <div className='recipe-slider__inner'>
           {
                recipes.length > 0 && (
                    <MemoMultiCarousel {...{ carouselSettings }} customHeader={<CustomHeader {...{ heading, filters, onClick: FilterItems, currentFilter }} />}>
                        {
                            filteredRecipes.map((recipe, key) => (
                                <RecipeItem key={key} categories={[...recipe.categories]} { ...recipe } />
                            ))
                        }
                    </MemoMultiCarousel>
                )
            }
        </div>
    )
}

const CustomHeader = ({ heading, filters, onClick, currentFilter }) => {
    return (
        <div className='carousel-header__heading'>
            <h2>{heading}</h2>
            <div className='carousel-header__filter'>
                {
                    filters.length > 0 && filters.map((filter, key) => (
                        <button key={key}
                            onClick={() => onClick(filter)}
                            className="button button--small"
                            aria-selected={currentFilter == filter.key}>
                            {filter.value}
                        </button>
                    ))
                }
            </div>
        </div>        
    )
}

const RecipeItem = ({ title, imageurl, url, reference, time, level, leveltext }) => {
    return (
        <div className='recipe-slider-item'>
            <img src={imageurl} alt={title} loading="lazy" className='recipe-slider-item__image' />
            <a href={url} className='recipe-slider-item__link' />
            <div className='recipe-slider-item__info'>
                <div className='recipe-slider-item__title'>{title}</div>
                <div className='recipe-slider-item__rating'>
                    <div data-bv-show="inline_rating" data-bv-product-id={reference}></div>
                </div>
            </div>
            <div className='recipe-slider-item__footer'>
                {
                    time && (
                        <div className='recipe-slider-item__footer-time'>
                            { time }
                        </div>
                    )
                }

                {
                    level && (
                        <div className={`recipe-slider-item__footer-level recipe-slider-item__footer-level--${level}`}>
                            { leveltext }
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default RecipeListCarousel;